import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ThemeService } from '../../../../../../core/auth/_services/theme.service';

@Component({
  selector: 'custom-gauge',
  templateUrl: './custom-gauge.component.html',
  styleUrls: ['./custom-gauge.component.scss']
})
export class CustomGaugeComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private destroy$ = new Subject<void>();
  @Input() value:number;
  @Input() title: string;
  @Input() product: string = 'Sin producto';
  @Input() arcDelimiters: number[];
  @Input() rangeLabel: string[];
  @Input() units: string = "golpes/min";
  public needleValue: number = 0;

  @ViewChild('gauge', {static: true}) container : ElementRef;
  canvasWidth:number = 0;
  public centralLabel = '0'
  public options = {
      hasNeedle: true,
      needleColor: 'rgb(61, 57, 79)',
      needleUpdateSpeed: 1000,
      arcColors: ['rgb(61, 57, 79)', '#f6954b'],
      arcDelimiters: [50],
      rangeLabel: ['0', '100'],
      needleStartValue: 0,
  }
  lastValue:number = 0;

  // private subscriptions: Subscription[] = [];

  constructor(
    private elRef: ElementRef,
    private themeService: ThemeService,
    private cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.options.arcDelimiters = this.arcDelimiters;
    this.options.rangeLabel = this.rangeLabel;
    this.options.needleStartValue = this.lastValue;
    this.needleValue = Math.round((this.value/parseFloat(this.rangeLabel[1])*100)*100)/ 100;
    this.lastValue = this.needleValue;
    this.centralLabel = this.value.toFixed(1).toString();//this.needleValue.toString();
    // console.log(`new value for lastValue: ${this.lastValue}`);
    // console.log(`from ${this.options.needleStartValue} to ${this.needleValue}`);
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.options.arcDelimiters = this.arcDelimiters;
    // this.subscriptions.push(
      this.themeService.currentTheme$.pipe(
        filter(theme=>theme!=null),
        takeUntil(this.destroy$)
      ).subscribe(theme=>{
        //console.log("theme gauge: ");console.dir(theme);
        const colors = theme.getCssVarObj();
        this.options.needleColor = colors['color-gauge-needle'];
        this.options.arcColors = [colors['color-gauge-arc1'], colors['color-gauge-arc2']];
      })
    // )
    this.canvasWidth = this.container.nativeElement.offsetWidth;
  }

  ngAfterViewInit(): void {
    this.canvasWidth = this.container.nativeElement.offsetWidth;
    //console.log(`width container: ${this.container.nativeElement.offsetWidth}`)
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
    // this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
}
